"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames_1 = require("classnames");
var react_redux_1 = require("react-redux");
var myokay_map3_1 = require("@okay/myokay-map3");
var EstateMapAction_1 = require("@/pages/estate/actions/EstateMapAction");
var getPins_1 = require("@/pages/estate/transformers/getPins");
var mapStateToProps = function (state) {
    var _a;
    var MINZOOM = 10;
    var MAXZOOM = 18;
    var selectedPhaseId = ((_a = state.estate.phases.find(function (it) { return it.mapActive; })) === null || _a === void 0 ? void 0 : _a.id) || -1;
    var allBlocks = state.estate.blocks.filter(function (it) { return it.location.lat; });
    var blocksInSelectedPhase = allBlocks
        .filter(function (it) { return (selectedPhaseId >= 0 ? it.parentPhaseId === selectedPhaseId : true); });
    return {
        camera: myokay_map3_1.getCameraFromLatLngs(blocksInSelectedPhase.map(function (it) { return it.location; }), state.estate.pixelWidth, MAXZOOM),
        pins: getPins_1.getPins(allBlocks, selectedPhaseId),
        minZoom: MINZOOM,
        zoomControl: false,
        blocks: state.estate.blocks,
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    onCancel: function () { return dispatch(EstateMapAction_1.default.onCancel()); },
    onViewportChanged: function () { return dispatch(EstateMapAction_1.default.onViewportChanged()); },
    onMapReady: function () { return dispatch(EstateMapAction_1.default.onMapReady()); },
    onPinClick: function (i) { return dispatch(EstateMapAction_1.default.onPinClick(i)); },
}); };
var estateMap = function (props) {
    var renderer = function (map, pin) {
        if (pin.value === 2) {
            var pinClass_1 = classnames_1.default([
                'c-maplabel', 'c-maplabel--nooffset',
            ]);
            return (React.createElement("div", { className: pinClass_1 },
                React.createElement("div", { className: "c-maplabel__body" }, pin.title)));
        }
        var pinClass = classnames_1.default(['c-mapcluster', 'c-mapcluster--nooffset', 'c-mapcluster--dot', {
                'c-mapcluster--darker': pin.value === 1,
                'c-mapcluster--bg': pin.value === -1,
            }]);
        var onClick = function () {
            var blockIndex = props.blocks.findIndex(function (it) { return it.name === pin.title; });
            props.onPinClick(blockIndex);
        };
        return React.createElement("div", { style: { cursor: 'pointer' }, onClick: onClick, className: pinClass });
    };
    return (React.createElement(myokay_map3_1.Renderer, { camera: props.camera, pins: props.pins, minZoom: props.minZoom, zoomControl: props.zoomControl, pinRenderer: renderer, onCancel: props.onCancel, onViewportChanged: props.onViewportChanged, onMapReady: props.onMapReady, gestureHandling: 'cooperative' }));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(estateMap);
